"use strict";

class IntermediateAPI {

  constructor()
  {
    this.url = 'https://yp-ec-ph2-proto.myshopify.com/apps/function/create-draft-order?code=LzKde422N9peqMX2lTRyq9UXVNY1lLu0EajhLQyFI4sAAzFuINKQGg==';
  }

  // API送信
  async sendAPI(data) {
    return await fetch(this.url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      return response.json();
    })
    .catch((reason) => {
      console.log('error', reason);
    });
  }

  // 下書き注文の作成
  async createDraftOrder(data) {
    return await this.sendAPI(data);
  }

} 